import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedGrid } from './components/IncludedGrid';
import { ModulesSection } from './components/ModulesSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { TransformSection } from './components/TransformSection';
import { PricingCard } from './components/PricingCard';
import { WhyCoaches } from './components/WhyCoaches';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1767171584537640');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="35yq6nee9s31">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1767171584537640&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="35ovwnmbgyrj" />
      </noscript>
      <div className="w-full min-h-screen bg-ivory text-petrol overflow-x-hidden" data-id="element-2" data-mp="d45t42bum9m1">
        <main data-id="element-3" data-mp="86mgf6usu4w7">
          <Hero data-id="element-4" data-mp="8648hcyry28g" />
          <StatsBar data-id="element-5" data-mp="83i2vivg1wsv" />
          <ProblemSection data-id="element-6" data-mp="3glea6jyr55fp" />
          <SolutionSection data-id="element-7" data-mp="3gklbm69y5m8n" />
          <IncludedGrid data-id="element-8" data-mp="3glwb3twd07ty" />
          <ModulesSection data-id="element-9" data-mp="3gj1ru5p30t24" />
          <LookInside data-id="element-10" data-mp="3bmtjbb5e3y3x" />
          <BonusSection data-id="element-11" data-mp="3bncorsdusu12" />
          <TransformSection data-id="element-12" data-mp="3bo4mp9uxb3ui" />
          <PricingCard data-id="element-13" data-mp="3qb7klhn5reid" />
          <WhyCoaches data-id="element-14" data-mp="3qbfwp7bgifsi" />
          <Guarantee data-id="element-15" data-mp="3qbzemo13x46j" />
          <Testimonials data-id="element-16" data-mp="3qcipxlw94ubl" />
          <FAQ data-id="element-17" data-mp="3lkhf84eqfbno" />
          <FinalCTA data-id="element-18" data-mp="3ljxtsdpvi54w" />
        </main>
        <Footer data-id="element-19" data-mp="3liwjwcklfoor" />
      </div>
    </>;
}